var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C22.4303 0 0 22.4303 0 50C0 77.5697 22.4303 100 50 100C77.5697 100 100 77.5697 100 50C100 22.4303 77.5697 0 50 0ZM37.9279 28.0817C40.9736 24.8534 45.2596 23.0769 50 23.0769C54.7404 23.0769 58.988 24.8654 62.0457 28.1106C65.1442 31.399 66.6514 35.8173 66.2957 40.5673C65.5841 50 58.2764 57.6923 50 57.6923C41.7236 57.6923 34.4014 50 33.7043 40.5649C33.351 35.7764 34.8558 31.3438 37.9279 28.0817V28.0817ZM50 92.3077C44.3521 92.3114 38.7609 91.181 33.5581 88.9834C28.3552 86.7858 23.6466 83.5658 19.7115 79.5144C21.9653 76.3004 24.8369 73.5677 28.1587 71.476C34.2861 67.5481 42.0409 65.3846 50 65.3846C57.9591 65.3846 65.7139 67.5481 71.8341 71.476C75.1586 73.5667 78.0328 76.2995 80.2885 79.5144C76.3537 83.5663 71.6452 86.7865 66.4422 88.9842C61.2393 91.1818 55.648 92.312 50 92.3077V92.3077Z",
    fill: "#4132B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.3071ba8170adad4e325e337b8671cc1f.svg";
export { ForwardRef as ReactComponent };